<template>
  <div class="main">
    <!-- <div>project id: {{ id }}</div>
    <div>Name: {{ projects[id].fields.shortname }}</div> -->
    <div class="nav__buttons">
      <div class="button__container">
        <div class="previous">
          <a class="id">{{ id + 1 }} — {{ projects.length }}</a>
          <router-link class="previous__lable" v-if="(id - 1) >= 0" :to="{ name: 'projects', params: { project_id: id - 1}}">Previous</router-link>
        </div>
        <div class="next">
          <router-link class="next__lable" v-if="(id + 1) < projects.length" :to="{ name: 'projects', params: { project_id: id + 1}}">Next</router-link>
        </div>
      </div>
    </div>
    <div class="projects">
        
        <template v-if="windowWidth <= 1280">
      <div class="project__information">
        <div class="about firstCol">
          <p class="about__title">{{ projects[id].title }}</p>
          <br>
        <div class="description">
            <p v-if="projects[id].description">{{ projects[id].description.paragraph1 }}</p>
            <p v-if="projects[id].description">{{ projects[id].description.paragraph2 }}</p>
        </div>
        </div>
        <div class="secondCol">
            <div class="about__types sub1">
            <p v-if="projects[id].types" class="about__type">{{ projects[id].types.type1 }}</p>
            <p v-if="projects[id].types" class="about__type">{{ projects[id].types.type2 }}</p>
          </div>
        <div class="sub2">
          <p v-if="projects[id].studio" class="about__about">Studio: <span> {{ projects[id].studio }}</span></p>
          <p v-if="projects[id].artDirection" class="about__about">Art Direction: <span> {{ projects[id].artDirection }}</span></p>
          <p v-if="projects[id].designer" class="about__about">Designer: <span> {{ projects[id].designer }}</span></p>
          <p v-if="projects[id].codesigner" class="about__about">Collaborators: <span> {{ projects[id].codesigner }}</span></p>
        </div>
        </div>
      </div>
        </template>
        
        <template v-if="windowWidth > 1280">
      <div class="project__information">
        <div class="about firstCol">
          <p class="about__title">{{ projects[id].title }}</p>
          <br>
        </div>
          <div class="secondRow">
        <div class="description">
            <p v-if="projects[id].description">{{ projects[id].description.paragraph1 }}</p>
            <p v-if="projects[id].description">{{ projects[id].description.paragraph2 }}</p>
        </div>
        </div>
        <div class="secondCol">
            <div class="about__types sub1">
            <p v-if="projects[id].types" class="about__type">{{ projects[id].types.type1 }}</p>
            <p v-if="projects[id].types" class="about__type">{{ projects[id].types.type2 }}</p>
          </div>
        <div class="sub2">
          <p v-if="projects[id].studio" class="about__about">Studio: <span> {{ projects[id].studio }}</span></p>
          <p v-if="projects[id].artDirection" class="about__about">Art Direction: <span> {{ projects[id].artDirection }}</span></p>
          <p v-if="projects[id].designer" class="about__about">Designer: <span> {{ projects[id].designer }}</span></p>
          <p v-if="projects[id].codesigner" class="about__about">Collaborators: <span> {{ projects[id].codesigner }}</span></p>
        </div>
        </div>
      </div>
        </template>
    
      <img class="tile hero images" v-for="image in projects[id].images" :src="image.title" alt="" :key="image.id">
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'projects',
  data: function () {
    return {
      windowWidth: window.innerWidth
    }
  },
  computed: {
    id () {
      if (this.$route.params.project_id) {
        return this.$route.params.project_id
      } else {
        return 0
      }
    },
    ...mapGetters([
      'general',
      'projects'
    ])
  }
}
</script>
<style scoped lang="scss">
@import "../scss/vars";

.project__information {
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  padding-bottom: 3rem;
}
.about {
  width: 100%;
  & p {
    margin: 0;
  }
}
.about__types {
  display: flex;
  flex-flow: row;
}
.about__title {
  font-size: $font-size-title;
  color: $font-color__second;
  font-weight: bold;
}
.about__type{
  color: $font-color__second;
  // text-decoration: underline;
}
.about__about{
  color: $font-color__second;
  font-weight: bold;
  letter-spacing: 1px;
  & span {
    letter-spacing: normal;
    font-weight: normal;
  }
}
.description {

}
.number {
  display: none;
}
.nav__buttons {
width: 100%;
  height: 3rem;
  display: flex;
  justify-content: center;
}
.button__container {
  width: 100%;
  padding-left: 0em;
  padding-right: 0em;
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  z-index: 10;
}
.previous {
  display: flex;
}
.previous__lable {
  color: $font-color__second;
  padding-right: 3rem;
  &:hover {
    text-decoration: underline;
  }
  order: 1;
}
.previous {
  display: flex;
}
.next__lable {
  color: $font-color__second;
  &:hover {
    text-decoration: underline;
  }
}

.id {
  color: $font-color__second;
  font-weight: bold;
  order: 2;
}

.tile {
  margin-bottom: 1rem;
}

@media screen and (min-width: $break-small) {

  .projects {
    width: 100%;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: auto;
    grid-gap: 24px;
  }
  .tile {
    grid-column: 3 / span 12;
    margin-bottom: 2rem;
    
  }
    
  .project__information {
/*    background: yellow;*/
    grid-column: 1 / span 12;
    display: grid;
      grid-template-columns: repeat(12, 1fr);
      grid-template-rows: auto;
      grid-gap: 24px;
/*
    display: flex;
    flex-flow: row;
    justify-content: flex-start;
*/
    padding-bottom: 3rem;
  }
  .about {
/*    width: 20rem;*/
    & p {
      margin: 0;
    }
  }
  .about__title {
    font-size: $font-size-title;
    color: $font-color__second;
    font-weight: bold;
    line-height: 32px;
  }
  .about__type{
    color: $font-color__second;
    // text-decoration: underline;
  }
  .about__about{
    color: $font-color__second;
    margin-bottom: -8px;
  }
  .description {
/*    width: 20rem;*/
    & p:first-child {
      margin-top: 0;
    }
  }
  .nav__buttons {
    width: 100%;
    padding-left: 4rem;
    padding-right: 4rem;
    position: fixed;
    top: 50vh;
    left: 0;
    right: 0;
    height: 7rem;
    display: flex;
    justify-content: center;
  }
  .button__container {
/*    margin-right: 8rem;*/
    margin: 0 auto;
    width: 100%;
    padding-left: 0rem;
    padding-right: 5.3rem;
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    z-index: 10;
  }
  .previous {
    transform: rotate(-90deg) translateX(-17rem);
    transform-origin: top left;
    display: block;
  }
  .previous__lable {
    padding-left: 10rem;
    color: $font-color__second;
    padding-right: 0rem;
    &:hover {
      text-decoration: underline;
    }
  }
  .next {
    color: $font-color__second;
    transform: rotate(90deg) translateX(1.5rem) translateY(-2.2rem);
    transform-origin: top left;
    &:hover {
      text-decoration: underline;
    }
  }
  .id {
    transform: rotate(-90deg);
    color: $font-color__second;
    font-weight: bold;
  }
    .firstCol {
        grid-column: 2 / span 7;
        grid-row: 1;
/*        background: red;*/
    }
    
    .secondCol {
        grid-column: 2 / span 7;
        grid-row: 2;
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        grid-gap: 24px;
/*        background: blue;*/
    }
    
    .sub1 {
        grid-column: 1 / span 3;
    }
    
    .sub2 {
        grid-column: 4 / span 4;
    }

}


@media screen and (min-width: $break-large) {
 
  .projects {
    width: 100%;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: auto;
    grid-gap: 24px;
  }
  .tile {
    grid-column: 3 / span 12;
    margin-bottom: 2rem;
    
  }
    
  .project__information {
    grid-column: 1 / span 12;
    display: grid;
      grid-template-columns: repeat(12, 1fr);
      grid-template-rows: auto;
      grid-gap: 24px;
    padding-bottom: 3rem;
  }
  .about {
    & p {
      margin: 0;
    }
  }
  .about__title {
    font-size: $font-size-title;
    color: $font-color__second;
    font-weight: bold;
    line-height: 32px;
  }
  .about__type{
    color: $font-color__second;
    // text-decoration: underline;
  }
  .about__about{
    color: $font-color__second;
    margin-bottom: -8px;
  }
  .description {
/*    width: 20rem;*/
    & p:first-child {
      margin-top: 0;
    }
  }
  .nav__buttons {
    width: 100%;
    padding-left: 5rem;
    padding-right: 5rem;
    position: fixed;
    top: 50vh;
    left: 0;
    right: 0;
    height: 7rem;
    display: flex;
    justify-content: center;
  }
  .button__container {
/*    margin-right: 10rem;*/
    margin: 0 auto;
    width: 100%;
    padding-left: 0rem;
    padding-right: 7rem;
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    z-index: 10;
  }
  .previous {
    transform: rotate(-90deg) translateX(-17rem);
    transform-origin: top left;
    display: block;
  }
  .previous__lable {
    padding-left: 10rem;
    color: $font-color__second;
    padding-right: 0rem;
    &:hover {
      text-decoration: underline;
    }
  }
  .next {
    color: $font-color__second;
    transform: rotate(90deg) translateX(1.5rem) translateY(-2.2rem);
    transform-origin: top left;
    &:hover {
      text-decoration: underline;
    }
  }
  .id {
    transform: rotate(-90deg);
    color: $font-color__second;
    font-weight: bold;
  }
    
    .firstCol {
        grid-column: 3 / span 5;
        grid-row: 1;
    }
    
    .secondRow {
        grid-column: 3 / span 5;
        grid-row: 2;
    }
    
    .secondCol {
        grid-column: 8 / span 3;
        grid-row: 2;
        margin-top: -16px;
        padding-left: 40px;
        display: flex;
        flex-direction: column;
/*
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 24px;
*/
/*        background: blue;*/
    }
    
}

    @media screen and (min-width: $break-xlarge) {
        .button__container {
/*    margin-right: 10rem;*/
    margin: 0 auto;
    width: 100%;
    padding-left: 0rem;
    padding-right: 10rem;
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    z-index: 10;
  }
    }
    
.images {
    grid-column: 2 / span 10;
}

</style>
